import React from 'react';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
export function Guarantee() {
  return <section className="py-10 px-4 bg-brand-50" data-id="element-117">
      <div className="max-w-3xl mx-auto" data-id="element-118">
        <div className="bg-white rounded-2xl p-5 md:p-7 border-2 border-brand-200 shadow-xl text-center relative overflow-hidden" data-id="element-119">
          <div className="absolute top-0 left-0 w-full h-2 bg-brand-500" data-id="element-120"></div>

          <div className="mx-auto w-14 h-14 bg-brand-100 text-brand-600 rounded-full flex items-center justify-center mb-3 mt-1" data-id="element-121">
            <VerifiedUserIcon sx={{
            fontSize: 36
          }} data-id="element-122" />
          </div>

          <h2 className="text-2xl font-extrabold text-slate-900 mb-3" data-id="element-123">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <p className="text-base text-slate-700 mb-3 font-medium" data-id="element-124">
            Entrás al sistema. Leés los tomos. Aplicás el método.
          </p>

          <div className="bg-brand-50 p-3 rounded-xl mb-3" data-id="element-125">
            <p className="font-bold text-brand-800 text-base mb-1" data-id="element-126">
              Y si sentís que no era lo que esperabas:
            </p>
            <p className="text-slate-700 text-sm" data-id="element-127">
              Te devolvemos el 100% de tu dinero.
            </p>
          </div>

          <p className="text-slate-600 font-medium text-sm" data-id="element-128">
            Sin vueltas. Sin formularios complicados.{' '}
            <span className="font-bold text-slate-900" data-id="element-129">
              El riesgo es nuestro.
            </span>
          </p>
        </div>
      </div>
    </section>;
}